import { useCallback } from 'react';
import { generateRandomId } from '../../../lib/random';
import { isAccepted } from './filter-file-type';
import type { FileListItem } from './types';

/**
 * What happens to files once a platform's drop zone hands them over. Pass `accept` only
 * where that drop zone doesn't already enforce it — Polaris's filters natively.
 */
export function useFileSelection({
  multi,
  value,
  onChange,
  accept,
}: {
  multi: boolean;
  value: FileListItem[];
  onChange: (files: FileListItem[]) => void;
  accept?: string[];
}) {
  const addFiles = useCallback(
    (selected: File[]) => {
      const accepted = accept ? selected.filter((file) => isAccepted(file, accept)) : selected;
      const newFiles = accepted.map((file) => ({ id: generateRandomId(), file }));

      onChange(multi ? [...value, ...newFiles] : newFiles.slice(0, 1));
    },
    [value, multi, accept, onChange],
  );

  const removeFile = useCallback(
    (id: string) => onChange(value.filter((file) => file.id !== id)),
    [value, onChange],
  );

  return { addFiles, removeFile };
}
